export class OnErrorSrcDirective {
    constructor() { }
    link(scope, element, attrs) {
        element.bind('error', () => {
            if (attrs.src != attrs.onErrorSrc) {
                attrs.$set('src', attrs.onErrorSrc);
            }
        });
    }
    static factory() {
        return new OnErrorSrcDirective();
    }
}
